import api from './client';

export const getPlans         = ()     => api.get('/payments/plans');
export const createPayment    = (data) => api.post('/payments/create', data);
export const getPaymentHistory = ()    => api.get('/payments/history');
